import { render, staticRenderFns } from "./ApplicationInstrumentation.vue?vue&type=template&id=4bbef9aa&scoped=true"
import script from "./ApplicationInstrumentation.vue?vue&type=script&lang=js"
export * from "./ApplicationInstrumentation.vue?vue&type=script&lang=js"
import style0 from "./ApplicationInstrumentation.vue?vue&type=style&index=0&id=4bbef9aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbef9aa",
  null
  
)

export default component.exports